// extracted by mini-css-extract-plugin
module.exports = {"readableTitle":"_14-QwZReFpsyK6Mr9COlKO"};